// extracted by mini-css-extract-plugin
module.exports = {"root":"hero_root__LE1DJ","outer":"hero_outer__28Qfj","inner":"hero_inner__1CV1y","heading":"hero_heading__1HTA_"};